"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonFungibleTokenOfAccountOnNetwork = exports.FungibleTokenOfAccountOnNetwork = void 0;
const bignumber_js_1 = require("bignumber.js");
const address_1 = require("../address");
const nonce_1 = require("../nonce");
class FungibleTokenOfAccountOnNetwork {
    constructor() {
        this.identifier = "";
        this.balance = new bignumber_js_1.BigNumber(0);
    }
    static fromHttpResponse(payload) {
        let result = new FungibleTokenOfAccountOnNetwork();
        result.identifier = payload.tokenIdentifier || payload.identifier || "";
        result.balance = new bignumber_js_1.BigNumber(payload.balance || 0);
        return result;
    }
}
exports.FungibleTokenOfAccountOnNetwork = FungibleTokenOfAccountOnNetwork;
class NonFungibleTokenOfAccountOnNetwork {
    constructor() {
        this.identifier = "";
        this.collection = "";
        this.attributes = Buffer.from([]);
        this.balance = new bignumber_js_1.BigNumber(0);
        this.nonce = new nonce_1.Nonce(0);
        this.creator = new address_1.Address("");
        this.royalties = new bignumber_js_1.BigNumber(0);
    }
    static fromProxyHttpResponse(payload) {
        let result = NonFungibleTokenOfAccountOnNetwork.fromHttpResponse(payload);
        result.identifier = payload.tokenIdentifier || "";
        result.collection = NonFungibleTokenOfAccountOnNetwork.parseCollectionFromIdentifier(result.identifier);
        result.royalties = new bignumber_js_1.BigNumber(payload.royalties || 0).div(100);
        return result;
    }
    static fromProxyHttpResponseByNonce(payload) {
        let result = NonFungibleTokenOfAccountOnNetwork.fromHttpResponse(payload);
        result.identifier = `${payload.tokenIdentifier}-${result.nonce.hex()}`;
        result.collection = payload.tokenIdentifier || "";
        result.royalties = new bignumber_js_1.BigNumber(payload.royalties || 0).div(100);
        return result;
    }
    static fromApiHttpResponse(payload) {
        let result = NonFungibleTokenOfAccountOnNetwork.fromHttpResponse(payload);
        result.identifier = payload.identifier || "";
        result.collection = payload.collection || "";
        return result;
    }
    static fromHttpResponse(payload) {
        let result = new NonFungibleTokenOfAccountOnNetwork();
        result.attributes = Buffer.from(payload.attributes || "", "base64");
        result.balance = new bignumber_js_1.BigNumber(payload.balance || 1);
        result.nonce = new nonce_1.Nonce(payload.nonce || 0);
        result.creator = new address_1.Address(payload.creator || "");
        result.royalties = new bignumber_js_1.BigNumber(payload.royalties || 0);
        return result;
    }
    static parseCollectionFromIdentifier(identifier) {
        let parts = identifier.split("-");
        let collection = parts.slice(0, 2).join("-");
        return collection;
    }
}
exports.NonFungibleTokenOfAccountOnNetwork = NonFungibleTokenOfAccountOnNetwork;
//# sourceMappingURL=tokens.js.map